
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { Checkbox, InputGroup } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledBoolField } from '../utils';
export const ControlledGroup = ({
  children
}) => {
  const [checked, setChecked] = useState({
    1: false,
    2: true,
    3: false,
    4: false
  });
  const handleOnChange = (value, name) => {
    setChecked({
      ...checked,
      [name]: value
    });
  };
  return children({
    checked,
    setChecked,
    handleOnChange
  });
};

const layoutProps = {
  ControlledGroup
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Checkbox`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Checkbox } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledBoolField component={
  <Checkbox />
} />`} component={Checkbox} mdxType="Playground">
  <ControlledBoolField component={<Checkbox mdxType="Checkbox" />} mdxType="ControlledBoolField" />
</Playground>
<p><inlineCode parentName="p">{`Checkbox`}</inlineCode>{` also has a `}<inlineCode parentName="p">{`read-only`}</inlineCode>{` state when no `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` function is specified:`}</p>
<Playground __position={1} __code={`<InputGroup>
  <Checkbox>
    I'm a read-only checkbox
  </Checkbox>
  <Checkbox value={true}>
    I'm a read-only checkbox
  </Checkbox>
</InputGroup>`} mdxType="Playground">
  <InputGroup mdxType="InputGroup">
    <Checkbox mdxType="Checkbox">
      I'm a read-only checkbox
    </Checkbox>
    <Checkbox value={true} mdxType="Checkbox">
      I'm a read-only checkbox
    </Checkbox>
  </InputGroup>
</Playground>
<h3>{`Intermediate state example`}</h3>
<p>{`This is useful when you have a checkbox that should handle multiple checkboxes at once and represents their combined state.`}</p>

<Playground __position={2} __code={`<ControlledGroup>
  {({ checked, setChecked, handleOnChange }) => (
    <InputGroup>
      <Checkbox
        onChange={(value) => 
          setChecked(Object.keys(checked).reduce((memo, check) => ({ ...memo, [check]: value }), {}))
        }
        value={Object.values(checked).some((c) => c)}
        indeterminate={! Object.values(checked).every((c) => c)}>
        All
      </Checkbox>
      <Checkbox name="1" value={checked['1']} onChange={handleOnChange} validate={() => console.log('validating')}>
        1 room apartment
      </Checkbox>
      <Checkbox name="2" value={checked['2']} onChange={handleOnChange}>
        2 room apartment
      </Checkbox>
      <Checkbox name="3" value={checked['3']} onChange={handleOnChange}>
        3 room apartment
      </Checkbox>
      <Checkbox name="4" value={checked['4']} onChange={handleOnChange}>
        Penthouse
      </Checkbox>
    </InputGroup>
  )}
</ControlledGroup>`} mode="jsx" mdxType="Playground">
  <ControlledGroup mdxType="ControlledGroup">
    {({
          checked,
          setChecked,
          handleOnChange
        }) => <InputGroup mdxType="InputGroup">
        <Checkbox onChange={value => setChecked(Object.keys(checked).reduce((memo, check) => ({
            ...memo,
            [check]: value
          }), {}))} value={Object.values(checked).some(c => c)} indeterminate={!Object.values(checked).every(c => c)} mdxType="Checkbox">
          All
        </Checkbox>
        <Checkbox name="1" value={checked['1']} onChange={handleOnChange} validate={() => console.log('validating')} mdxType="Checkbox">
          1 room apartment
        </Checkbox>
        <Checkbox name="2" value={checked['2']} onChange={handleOnChange} mdxType="Checkbox">
          2 room apartment
        </Checkbox>
        <Checkbox name="3" value={checked['3']} onChange={handleOnChange} mdxType="Checkbox">
          3 room apartment
        </Checkbox>
        <Checkbox name="4" value={checked['4']} onChange={handleOnChange} mdxType="Checkbox">
          Penthouse
        </Checkbox>
      </InputGroup>}
  </ControlledGroup>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;